exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___xqcaE {\n  margin-left: -20px;\n  margin-right: -20px;\n  background-color: #fcfcfc;\n}\n.container___xqcaE p {\n  font-weight: 400;\n  color: #505050;\n}\n.contentContainer___eSFOn {\n  padding: 24px 20px 20px;\n  max-width: 1440px;\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .contentContainer___eSFOn {\n    padding-left: 31px;\n    padding-right: 31px;\n  }\n}\n@media (min-width: 992px) {\n  .contentContainer___eSFOn {\n    padding-left: 38px;\n    padding-right: 38px;\n    padding-top: 20px;\n  }\n}\n@media (min-width: 1200px) {\n  .contentContainer___eSFOn {\n    padding-left: 62px;\n    padding-right: 62px;\n    padding-bottom: 60px;\n  }\n}\n@media (min-width: 1440px) {\n  .contentContainer___eSFOn {\n    padding-left: 70px;\n    padding-right: 70px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___xqcaE",
	"contentContainer": "contentContainer___eSFOn"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionLinkContainer/ConfigureAddressCollectionLinkContainer.module.less
// module id = 2355
// module chunks = 71